import {useEffect, React} from "react";
import "../styles/contact.css";
import Layout from "../tools/layout.js";
import { useFormik } from "formik";
import emailjs from "emailjs-com";

function Contact() {
  useEffect(() => {
    document.title = "Contact | Ion Niculica";
  }, []);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      message: ""
    },

    validate: (values) => {
      const errors = {};
      if (!values.firstName) errors.firstName = "Required";
      if (!values.lastName) errors.lastName = "Required";
      if (!values.email) {
        errors.email = "Required";
      } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = "Invalid email";
      }
      if (!values.message) errors.message = "Required";
      return errors;
    },

    onSubmit: (values, { resetForm }) => {
      const templateParams = {
        name: `${values.firstName} ${values.lastName}`,
        email: values.email,
        message: values.message,
        time: new Date().toLocaleString(),
      };

      emailjs.send(
        "service_8smcc51",
        "template_3vmcujm",
        templateParams,
        "MDNUkf0BasGrehGJ4"
      )
      .then(() => {
        alert("Message sent successfully :)");
        resetForm();
      })
      .catch(() => {
        alert("Error, the message isn't sent :(");
      });
    },
  });

  return (
    <Layout>
      <div className="contact">
        <div className="contact-container">
        <div className="contact-intro">
    <h2>Send me an email &#128233;</h2>
    <p>
      Feel free to chat, ask questions, or just say hello.<br/>{'(I guarantee a response)'}
    </p>
  </div>

          <form onSubmit={formik.handleSubmit}>

            <div className="person-info">
              <div>
                <label>First Name *</label>
                <input
                  name="firstName"
                  className={formik.errors.firstName && (formik.touched.firstName || formik.submitCount > 0) ? "input error" : "input"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                />
                {formik.errors.firstName && (formik.touched.firstName || formik.submitCount > 0) && (
                  <span className="error">{formik.errors.firstName}</span>
                )}
              </div>

              <div>
                <label>Last Name *</label>
                <input
                  name="lastName"
                  className={formik.errors.lastName && (formik.touched.lastName || formik.submitCount > 0) ? "input error" : "input"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                />
                {formik.errors.lastName && (formik.touched.lastName || formik.submitCount > 0) && (
                  <span className="error">{formik.errors.lastName}</span>
                )}
              </div>
            </div>

            <div className="person-data">
              <div>
                <label>Email *</label>
                <input
                  name="email"
                  type="email"
                  className={formik.errors.email && (formik.touched.email || formik.submitCount > 0) ? "input error" : "input"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.errors.email && (formik.touched.email || formik.submitCount > 0) && (
                  <span className="error">{formik.errors.email}</span>
                )}
              </div>

              <div>
                <label>Message *</label>
                <textarea
                  name="message"
                  className={formik.errors.message && (formik.touched.message || formik.submitCount > 0) ? "input error" : "input"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                />
                {formik.errors.message && (formik.touched.message || formik.submitCount > 0) && (
                  <span className="error">{formik.errors.message}</span>
                )}
              </div>
            </div>

            <button type="submit">Send</button>
          </form>
        </div>
      </div>
    </Layout>
  );
}

export default Contact;